// extracted by mini-css-extract-plugin
export default {"main_div":"confirmCart_main_div__z6B5Q","btn_section":"confirmCart_btn_section__9X5Hl"};